import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { TextField } from "@similarweb/ui-components/forms";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { CAMPAIGN_WIZARD_TRANSLATIONS } from "../translations";
import { MAX_STRING_CHARACTERS, validateCampaignName } from "../utils/campaign-name-validation";

const FullWidthTextField = styled(TextField)`
    width: 100%;
`;

interface ICampaignNameStepProps {
    campaignName: string;
    onCampaignNameChange: (name: string) => void;
}

interface ICampaignNameStepFooterProps {
    isValid: boolean;
    isLoading?: boolean;
    onBack: () => void;
    onDone: () => void;
}

export const CampaignNameStepHeader = () => {
    return (
        <Text
            fontVariant="h5_2"
            color={colorsPalettes.carbon["500"]}
        >
            {CAMPAIGN_WIZARD_TRANSLATIONS.name.header.translate()}
        </Text>
    );
};

export const CampaignNameStepFooter = ({ onBack, onDone, isValid, isLoading }: ICampaignNameStepFooterProps) => {
    return (
        <Flex
            width="100%"
            justifyContent="space-between"
        >
            <Button
                type="flat"
                onClick={onBack}
            >
                {CAMPAIGN_WIZARD_TRANSLATIONS.name.back.translate()}
            </Button>
            <Button
                onClick={onDone}
                isLoading={isLoading}
                isDisabled={!isValid || isLoading}
            >
                {CAMPAIGN_WIZARD_TRANSLATIONS.name.done.translate()}
            </Button>
        </Flex>
    );
};

export const CampaignNameStep = ({ campaignName, onCampaignNameChange }: ICampaignNameStepProps) => {
    const isAtMaxLength = campaignName.length >= MAX_STRING_CHARACTERS;

    return (
        <Flex minHeight="90px">
            <FullWidthTextField
                label={CAMPAIGN_WIZARD_TRANSLATIONS.name.fieldLabel.translate()}
                autoFocus
                value={campaignName}
                onChange={onCampaignNameChange}
                placeholder={CAMPAIGN_WIZARD_TRANSLATIONS.name.placeholder.translate()}
                maxLength={MAX_STRING_CHARACTERS}
                validate={(value) => validateCampaignName(value).error ?? null}
                errorMessage={(validation) =>
                    validation.validationErrors.length > 0 ? validation.validationErrors[0] : null
                }
                description={
                    isAtMaxLength ? CAMPAIGN_WIZARD_TRANSLATIONS.name.validation.maxLength.translate() : undefined
                }
            />
        </Flex>
    );
};
